import { tns } from 'tiny-slider/src/tiny-slider';

export default (() => {

  window.instancesFeaturesSlider = [];
  
    $('.feature-slider-wrapper').each(function(i) {
        window.instancesFeaturesSlider.push(tns({
            container: $(this)[0],
            lazyload: false,
            autoplay: false,
            autoplayButtonOutput: false,
            speed: 1000,
            touch: true,
            controls: true,
            controlsText: ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>'],
            nav: false,
            loop: false,
            gutter: 20,
            responsive: {
                1: {
                  items: 1,
                },
                768: {
                    items: 2,
                },
                1200: {
                    items: 4,
                },
              },
        }));

        $(this).find('.first-mobile').click(function() {
          window.instancesFeaturesSlider[i].goTo('first');
        })

        $(this).find('.next-mobile').click(function() {
            window.instancesFeaturesSlider[i].goTo('next');
        });
    });
});



// WEBPACK FOOTER //
// ./scripts/components/feature-slider.js